/* eslint-disable react/jsx-pascal-case */
import React, { useContext, useCallback } from 'react';
import { ThemeProvider } from 'styled-components';
import { icons } from './icons';
import { BasicIconProps } from './types';
import { SvgContainer } from './styles';
import { ThemeContext } from '../ThemeProvider/ThemeProvider';

const BasicIcon = ({
  id,
  name,
  size = 'medium',
  color = '#4d4d4d',
  onClick,
  disabled,
  clickable,
}: BasicIconProps) => {
  const { actualTheme } = useContext(ThemeContext);
  const Icon = icons[name] || icons.exclamation;
  const handleClick = useCallback(
    (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
      if (onClick && !disabled) {
        e.stopPropagation();
        onClick();
      }
    },
    [onClick, disabled],
  );

  return (
    <ThemeProvider theme={actualTheme}>
      <SvgContainer
        id={id}
        color={color}
        size={size}
        data-testid={id || 'icon-test-id'}
        onClick={handleClick}
        clickable={(typeof clickable === 'undefined' ? !!onClick : clickable) && !disabled}
        disabled={disabled}
      >
        <Icon.component
          height={actualTheme.basicIcon[size].size}
          width={actualTheme.basicIcon[size].size}
          viewBox="0 0 16 16"
          name={name}
        />
      </SvgContainer>
    </ThemeProvider>
  );
};

export default BasicIcon;
